import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countrySelect", "phoneCode"]
  static values = { phoneCodeSelector: String }

  updatePhoneCode() {
    const selected = this.countrySelectTarget.selectedOptions[0]
    if (!selected || !selected.dataset.phoneCode) return

    const phoneCode = selected.dataset.phoneCode

    // Try target first, then fall back to selector value
    if (this.hasPhoneCodeTarget) {
      this.phoneCodeTarget.value = phoneCode
    } else if (this.hasPhoneCodeSelectorValue) {
      const el = document.querySelector(this.phoneCodeSelectorValue)
      if (el) el.value = phoneCode
    }
  }
}
